import React, { useCallback, useEffect, useMemo, useState } from "react";
import {
  Container,
  Row,
  Col,
  Card,
  CardBody,
  Form,
  FormGroup,
  Label,
  Button
} from "reactstrap";
import { useFormik } from "formik";
import * as Yup from "yup";
import Select from "react-select";
import TableContainer from '../../../components/Common/TableContainer';
import Breadcrumbs from '../../../components/Common/Breadcrumb';
import { useDispatch, useSelector } from "react-redux";
import { fetchCategories, fetchDepartments, fetchDesignations, fetchEmployeeDropdownAutoList, fetchHolidayEmployee, fetchHolidays, removeEmployeeHoliday, resetHolidayEmployees } from "store/actions";
import CustomSelect from "components/Common/custom-select";
import { useAuthUserDetails } from "components/Common/getAuthUserDetails";
import { convertToInputDate } from "common/dateFormat/formatDate";
import Loader from "common/pageLoader";
import Swal from "sweetalert2";
import { useLocation,useHistory } from "react-router-dom";
import getAccessRights from "components/Common/getAccessRights";
import useButtonAccess from "components/Common/useButtonAccess";

const holidayData = [
  {
    code: "0",
    name: "AES Superadmin",
    category: "ADMIN STAFF",
    department: "ACCOUNTS",
    designation: "ACCOUNTANT",
    date: "16.01.25",
    description: "Pongal - Kanumu Pongal",
  },
  {
    code: "010",
    name: "Internal Audit",
    category: "ADMIN STAFF",
    department: "ACCOUNTS",
    designation: "ACCOUNTANT",
    date: "16.01.25",
    description: "Pongal - Kanumu Pongal",
  },
  {
    code: "IA00004",
    name: "GANESA PANDIAN",
    category: "ADMIN STAFF",
    department: "ACCOUNTS",
    designation: "CASHIER",
    date: "16.01.25",
    description: "Pongal - Kanumu Pongal",
  },
  {
    code: "IA00006",
    name: "SIVAGAMASUNDARI SENTHILKUMAR",
    category: "ADMIN STAFF",
    department: "HUMAN RESOURCE",
    designation: "SUB MANAGER HR",
    date: "16.01.25",
    description: "Pongal - Kanumu Pongal",
  },
];

const HolidayRemove = () => {
  const [accessRight, setAccessRight] = useState(null);
  const location = useLocation();
  const history = useHistory();
  useEffect(() => {
      const rights = getAccessRights(location.pathname, history);
      setAccessRight(rights?.data);
  }, [location]);
  const { canRead, canCreate, canEdit, canDelete, canApprove } = useButtonAccess(accessRight);
  const dispatch = useDispatch();
  const [authDetails, setAuthDetails] = useState(null);
  const {
    categories,
    departments,
    designations,
    dropdownAutoList,
    holidays,
    holidayEmployees,
    loading,
    success,
    error,
  } = useSelector((state) => ({
    categories: state.CategoryMaster?.categories,
    departments: state.DepartmentMaster?.departments,
    designations: state.DesignationMaster?.designations,
    dropdownAutoList: state.EmployeeDetailsReducer?.dropdownAutoList,
    holidays: state.holidayReducer?.holidays,
    holidayEmployees: state.holidayReducer?.holidayEmployees,

    loading: state.holidayReducer?.loading || state.CategoryMaster?.loading || state.DepartmentMaster?.loading || state.DesignationMaster?.loading || state.EmployeeDetailsReducer?.loading,
    error: state.holidayReducer?.error || state.CategoryMaster?.error || state.DepartmentMaster?.error || state.DesignationMaster?.error || state.EmployeeDetailsReducer?.error,
    success: state.holidayReducer?.success
  }));

  useEffect(() => {
    const authUserDetails = useAuthUserDetails();
    setAuthDetails(authUserDetails[0])
    const unitId = authUserDetails[0].unit_id
    dispatch(fetchCategories(unitId));
    dispatch(fetchDepartments(unitId));
    dispatch(fetchDesignations(unitId));
    dispatch(fetchEmployeeDropdownAutoList(unitId));
    dispatch(fetchHolidays(unitId));
  }, [dispatch]);

  useEffect(() => {
    if (success) {
      const formData = new FormData();
      formData.append("cat_ids", 0);
      formData.append("dept_ids", 0);
      formData.append("desig_ids", 0);
      formData.append("emp_ids", 0);
      formData.append("holiday_date", 0);
      formData.append("unit_id", authDetails?.unit_id);
      formData.append("create_by", authDetails?.user_id);
      dispatch(fetchHolidayEmployee(formData));
      formik.resetForm()
    }
  }, [authDetails, success, dispatch]);

  const formik = useFormik({
    initialValues: {
      category: "",
      department: "",
      designation: "",
      employee: "",
      holidays: "",
    },
    validationSchema: Yup.object({
      // category: Yup.array().required("Category is required"),
      // department: Yup.array().required("Department is required"),
      // designation: Yup.array().required("Designation is required"),
      // employee: Yup.array().required("Employee is required"),

      // holidays: Yup.array().required("Holidays is required"),
    }),
    onSubmit: (values) => {
      // console.log('values > ', values);
      const formData = new FormData();
      formData.append(
        "cat_ids",
        values.category && values.category.length ? values.category.map(item => item.value).join(",") : '0'
      );
      formData.append(
        "dept_ids",
        values.department && values.department.length ? values.department.map(item => item.value).join(",") : '0'
      );
      formData.append(
        "desig_ids",
        values.designation && values.designation.length ? values.designation.map(item => item.value).join(",") : '0'
      );
      formData.append(
        "emp_ids",
        values.employee && values.employee.length ? values.employee.map(item => item.value).join(",") : '0'
      );
      formData.append(
        "holiday_date",
        values.holidays && values.holidays.length ? values.holidays.map(item => item.date).join(",") : '0'
      );

      formData.append("unit_id", authDetails?.unit_id);
      formData.append("create_by", authDetails?.user_id);
      dispatch(fetchHolidayEmployee(formData));
    },
  });

  const [selectedRows, setSelectedRows] = React.useState([]);

  const columns = useMemo(() => [
    {
      Header: "SNo",
      Cell: ({ row }) => holidayEmployees.length - row.index,
      className: "serial-no",
      applyHeaderClass: true,
    },
    {
      Header: "Code",
      accessor: "emp_no",
    },
    {
      Header: "Name",
      accessor: "emp_name",
    },
    {
      Header: "Category",
      accessor: "category",
    },
    {
      Header: "Department",
      accessor: "department",
    },
    {
      Header: "Designation",
      accessor: "designation",
    },
    {
      Header: "Date",
      accessor: "holiday_date",
    },
    {
      Header: "Description",
      accessor: "description",
    },
    {
      id: "selection",
      className: "serial-no",
      applyHeaderClass: true,
      Header: ({ getToggleAllRowsSelectedProps }) => (
        <div className="text-center">
          <input type="checkbox" {...getToggleAllRowsSelectedProps()} />
        </div>
      ),
      Cell: ({ row }) => (
        <div className="text-center">
          <input type="checkbox" {...row.getToggleRowSelectedProps()} />
        </div>
      ),
    },
  ], [holidayEmployees]);



  // Memoize the callback so it doesn't change on every render
  const handleSelectedRowsChange = React.useCallback((rows) => {
    setSelectedRows(rows);
  }, []);

  const handleDelete = () => {
    if (selectedRows.length === 0) {
      Swal.fire({
        icon: "warning",
        title: "No rows selected",
        text: "Please select rows to delete.",
      });
      return;
    }

    const deletePayload = {
      hol: selectedRows.map(row => ({
        holiday_id: row.holiday_id.toString(),
        emp_id: row.emp_id.toString(),
        holiday_date: row.holiday_date
      }))
    };

    // Show confirmation dialog
    Swal.fire({
      title: "Are you sure?",
      text: "You won't be able to remove this!",
      icon: "warning",
      showCancelButton: true,
      confirmButtonColor: "#d33",
      cancelButtonColor: "#3085d6",
      confirmButtonText: "Yes, delete it!"
    }).then((result) => {
      if (result.isConfirmed) {
        const formData = new FormData();
        formData.append("lst_employee_holiday", JSON.stringify(deletePayload));
        formData.append("create_by", authDetails?.unit_id);
        dispatch(removeEmployeeHoliday(formData))
      }
    });
  };

  return (
    <React.Fragment>
      <div className="page-content">
        <Loader loading={loading} />
        <Container fluid className="mt-4">
          <Breadcrumbs title="Holiday" breadcrumbItem="Holiday Remove" />
          <Card>
            <CardBody>
              <Form onSubmit={formik.handleSubmit}>
                <Row>
                  <Col md={4} sm={12} className="mb-3">
                    <FormGroup>
                      <Label for="category">Category</Label>
                      <CustomSelect
                        id="category"
                        name="category"
                        options={categories.map(cat => ({ value: cat.empCatgryid.toString(), label: cat.empCategory }))}
                        value={formik.values.category || null}
                        onChange={(selectedOption) => formik.setFieldValue("category", selectedOption)}
                        onBlur={formik.handleBlur}
                        className={formik.touched.category && formik.errors.category ? 'is-invalid' : ''}
                        isMulti
                      />
                      {formik.touched.category && formik.errors.category && (
                        <div className="text-danger">{formik.errors.category}</div>
                      )}
                    </FormGroup>
                  </Col>
                  <Col md={4} sm={12} className="mb-3">
                    <FormGroup>
                      <Label for="department">Department</Label>
                      <CustomSelect
                        id="department"
                        name="department"
                        options={departments.map(cat => ({ value: cat.departmentId.toString(), label: cat.departmentname }))}
                        value={formik.values.department || null}  // Store full object
                        onChange={(selectedOption) => formik.setFieldValue("department", selectedOption)}
                        onBlur={formik.handleBlur}
                        className={formik.touched.department && formik.errors.department ? 'is-invalid' : ''}
                        isMulti
                      />
                      {formik.touched.department && formik.errors.department && (
                        <div className="text-danger">{formik.errors.department}</div>
                      )}
                    </FormGroup>
                  </Col>
                  <Col md={4} sm={12} className="mb-3">
                    <FormGroup>
                      <Label for="designation">Designation</Label>
                      <CustomSelect
                        id="designation"
                        name="designation"
                        options={designations.map(cat => ({ value: cat.desig_id.toString(), label: cat.designation }))}
                        value={formik.values.designation || null}  // Store full object
                        onChange={(selectedOption) => formik.setFieldValue("designation", selectedOption)}
                        onBlur={formik.handleBlur}
                        className={formik.touched.designation && formik.errors.designation ? 'is-invalid' : ''}
                        isMulti
                      />
                      {formik.touched.designation && formik.errors.designation && (
                        <div className="text-danger">{formik.errors.designation}</div>
                      )}
                    </FormGroup>
                  </Col>

                  {/* Employee Selection */}
                  <Col md={4} sm={12} className="mb-3">
                    <FormGroup>
                      <Label for="employee">Employee</Label>
                      <CustomSelect
                        id="employee"
                        name="employee"
                        options={dropdownAutoList.map(cat => ({ value: cat.emp_id.toString(), label: cat.emp_no }))}
                        value={formik.values.employee || null}  // Store full object
                        onChange={(selectedOption) => formik.setFieldValue("employee", selectedOption)}
                        onBlur={formik.handleBlur}
                        className={formik.touched.employee && formik.errors.employee ? 'is-invalid' : ''}
                        isMulti
                      />
                      {formik.touched.employee && formik.errors.employee && (
                        <div className="text-danger">{formik.errors.employee}</div>
                      )}
                    </FormGroup>
                  </Col>

                  <Col md={4} sm={12} className="mb-3">
                    <FormGroup>
                      <Label for="holidays">Holiday</Label>
                      <CustomSelect
                        id="holidays"
                        name="holidays"
                        options={holidays.map(cat => ({ value: cat.HolidayID.toString(), label: `${cat.Description}  -  ${cat.Date}`, date: convertToInputDate(cat.Date) }))}
                        value={formik.values.holidays || null}  // Store full object
                        onChange={(selectedOption) => formik.setFieldValue("holidays", selectedOption)}
                        onBlur={formik.handleBlur}
                        className={formik.touched.holidays && formik.errors.holidays ? 'is-invalid' : ''}
                        isMulti
                      />
                      {formik.touched.holidays && formik.errors.holidays && (
                        <div className="text-danger">{formik.errors.holidays}</div>
                      )}
                    </FormGroup>
                  </Col>
                  <Col md={4} className="mb-3 d-flex align-items-center justify-content-md-end justify-content-center ">
                    <Button type="submit" className="btn button-search me-2 mt-2">
                      <i className="fas fa-search me-1" /> Search
                    </Button>

                    <Button type="button" color="secondary" onClick={() => { formik.resetForm(); dispatch(resetHolidayEmployees()); }} className="btn button-cancel me-2 mt-2">
                      <i className="fas fa-sync me-1" /> Cancel
                    </Button>

                    {(canDelete && selectedRows.length > 0) && (
                      <Button type="button" className="btn button-delete me-2 mt-2" onClick={handleDelete}>
                        <i className="fas fa-trash me-1" /> Delete
                      </Button>

                    )}
                  </Col>
                </Row>
              </Form>
            </CardBody>
          </Card>

          <Card className="mt-4">
            <CardBody>
              <TableContainer
                columns={columns}
                data={holidayEmployees && holidayEmployees.length > 0 ? holidayEmployees : []}
                onSelectedRowsChange={handleSelectedRowsChange}
                isGlobalFilter={true}
                customPageSize={10}
                className="custom-header-css"
              />
            </CardBody>
          </Card>
        </Container>
      </div>
    </React.Fragment>
  );
};

export default HolidayRemove;
